import React, { useEffect, useState, useRef } from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { Button, Fab } from '@mui/material';
import { DiaCalendario } from './DiaCalendario';
import { TarjetaTarea } from './TarjetaTarea';
export const CalendarioGrid = ({ mesActual, anioActual, hoy, diaHoy, mesHoy, anioHoy, tareas, setTareas, opcionesTareas, estados }) => {
	const onDragEnd = (event) => {
		const { active, over } = event;
		if (over && active.id) {
			const nuevaFecha = over.id; // ID del día
			setTareas((prev) =>
				prev.map((t) => (t.id === active.id ? { ...t, fecha: nuevaFecha } : t))
			);
		}
	};
	const [diasExpandido, setDiasExpandido] = useState({});

	const [meses, setMeses] = useState(() => generarMesesCentrales(hoy, 6)); // 6 meses centrado
	const contenedorRef = useRef(null);

	const nombresDias = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

	useEffect(() => {
		const contenedor = contenedorRef.current;
		const handleScroll = () => {
			if (!contenedor) return;

			const { scrollTop, scrollHeight, clientHeight } = contenedor;

			// Scroll hacia abajo
			if (scrollTop + clientHeight >= scrollHeight - 300) {
				agregarMeses(3, 'abajo');
			}

			// Scroll hacia arriba
			if (scrollTop < 300) {
				const alturaAntes = contenedor.scrollHeight;
				agregarMeses(3, 'arriba', () => {
					// Corregir scroll tras insertar arriba
					const alturaDespues = contenedor.scrollHeight;
					contenedor.scrollTop += alturaDespues - alturaAntes;
				});
			}
		};

		contenedor.addEventListener('scroll', handleScroll);
		return () => contenedor.removeEventListener('scroll', handleScroll);
	}, [meses]);

	function generarMesesCentrales(baseDate, cantidad) {
		const lista = [];
		const base = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
		const offset = Math.floor(cantidad / 2);

		for (let i = -offset; i <= offset; i++) {
			const fecha = new Date(base.getFullYear(), base.getMonth() + i, 1);
			lista.push(crearMes(fecha));
		}

		return lista;
	}

	function crearMes(fecha) {
		const anio = fecha.getFullYear();
		const mes = fecha.getMonth();
		const nombreMes = fecha.toLocaleString('es-ES', { month: 'long' });
		const primerDia = new Date(anio, mes, 1);
		const ultimoDia = new Date(anio, mes + 1, 0);
		const diasEnMes = ultimoDia.getDate();

		const dias = [];
		let diaSemana = primerDia.getDay();
		diaSemana = diaSemana === 0 ? 6 : diaSemana - 1;

		for (let i = 0; i < diaSemana; i++) {
			dias.push(null);
		}

		for (let i = 1; i <= diasEnMes; i++) {
			dias.push(i);
		}

		return { anio, mes, nombreMes, dias };
	}

	const agregarMeses = (cantidad, direccion, callback) => {
		setMeses((prev) => {
			const nuevo = [...prev];
			for (let i = 1; i <= cantidad; i++) {
				const ref = direccion === 'abajo' ? nuevo[nuevo.length - 1] : nuevo[0];
				const fechaRef = new Date(ref.anio, ref.mes + (direccion === 'abajo' ? 1 : -1), 1);
				const nuevoMes = crearMes(fechaRef);
				if (direccion === 'abajo') {
					nuevo.push(nuevoMes);
				} else {
					nuevo.unshift(nuevoMes);
				}
			}

			if (callback) setTimeout(callback, 0); // ejecuta tras render
			return nuevo;
		});
	};


	const irAHoy = () => {
		const idHoy = `${String(diaHoy).padStart(2, '0')}-${String(mesHoy + 1).padStart(2, '0')}-${anioHoy}`;
		const celdaHoy = document.getElementById(idHoy);
		if (celdaHoy) {
			celdaHoy.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	};

	const toggleExpandirDia = (idDia) => {
		setDiasExpandido(prev => ({
			...prev,
			[idDia]: !prev[idDia]
		}));
	};
	return (
		<div
			ref={contenedorRef}
			style={{
				height: '90vh',
				overflowY: 'auto',
				padding: 16,
				scrollBehavior: 'smooth',
			}}
		>


			{meses.map(({ anio, mes, nombreMes, dias }) => (
				<Box key={`${mes}-${anio}`} mb={4}>
					<Typography variant="h6" textTransform="capitalize" gutterBottom>
						{nombreMes} {anio}
					</Typography>

					<Grid container spacing={1}>
						{nombresDias.map((dia) => (
							<Grid item xs={1.714} key={dia}>
								<Typography variant="subtitle2" align="center">
									{dia}
								</Typography>
							</Grid>
						))}
						{dias.map((dia, index) => {
							const esHoy = dia === diaHoy && mes === mesHoy && anio === anioHoy;
							const id = dia
								? `${String(dia).padStart(2, '0')}-${String(mes + 1).padStart(2, '0')}-${anio}`
								: undefined;

							return (
								<Grid item xs={1.714} key={index}>
									<Paper
										id={id}
										elevation={esHoy ? 4 : 1}
										style={{
											minHeight: 150,
											maxHeight: diasExpandido[id] ? 'none' : 120, // ← cambia aquí
											display: 'flex',
											alignItems: 'flex-start',
											justifyContent: 'center',
											backgroundColor: dia
												? esHoy
													? '#1976d2'
													: '#f5f5f5'
												: 'transparent',
											color: esHoy ? 'white' : 'black',
											fontWeight: esHoy ? 'bold' : 'normal',
											borderRadius: esHoy ? 8 : 4,
											overflow: 'visible',
											position: 'relative',
										}}
									>

										<DiaCalendario id={id} dia={dia} >
											{(() => {
												const tareasDelDia = tareas.filter((t) => t.fecha === id);
												const expandido = diasExpandido[id];
												const tareasVisibles = expandido ? tareasDelDia : tareasDelDia.slice(0, 2);

												return (
													<>
														{tareasVisibles.map((tarea) => (
															<TarjetaTarea key={tarea.id} id={tarea.id} tarea={tarea} opcionesTareas={opcionesTareas} estados={estados}/>
														))}
														{tareasDelDia.length > 2 && (
															<div
																onClick={() => toggleExpandirDia(id)}
																style={{
																	cursor: 'pointer',
																	fontSize: 12,
																	color: 'var(--principal)',
																	textAlign: 'center',
																	marginTop: 4,
																	userSelect: 'none',
																}}
															>
																{expandido ? '− Ver menos' : `+ ${tareasDelDia.length - 2} más`}
															</div>
														)}
													</>
												);
											})()}
										</DiaCalendario>

									</Paper>
								</Grid>
							);
						})}
					</Grid>
				</Box>
			))}
		</div>
	);
};
